import { useEffect } from "react";
import { saveAs } from "file-saver";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import Base64ToBlob from "../../../../components/Formatters/Base64ToBlob";

const useDocumentos = () => {
  const { request: requestDocumento, data: dataDocumento } = useApiClient();

  const showDocumento = (documentoOs, nomeArquivo, salvar) => {
    let byteArray = documentoOs;

    if (typeof byteArray === "string") {
      byteArray = Base64ToBlob(documentoOs);
    }

    if (nomeArquivo) {
      const tipoArquivo = nomeArquivo.split(".").pop();

      if (tipoArquivo !== "pdf" || salvar) {
        const file = new Blob([byteArray], { type: `application/${tipoArquivo}` });
        saveAs(file, nomeArquivo);
      } else {
        const file = new Blob([byteArray], { type: "application/pdf" });
        const url = URL.createObjectURL(file);
        window.open(url, "", "width=800,height=800");
      }
    } else {
      const file = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(file);
      window.open(url, "", "width=800,height=800");
    }
  };

  const buscaDocumento = (sqAcaoFiscal, sqOrdemServico, tipoDocumento) => {
    const values = { sqAcaoFiscal, sqOrdemServico, tipoDocumento };

    requestDocumento(apiRoutes.fiscalizacao.ocorrencia.downloadDocumento, values);
  };

  useEffect(() => {
    if (dataDocumento) {
      showDocumento(dataDocumento);
    }
  }, [dataDocumento]);

  return { buscaDocumento };
};

export default useDocumentos;
